import script from "./TariffView.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffView.vue?vue&type=script&setup=true&lang=js"

import "./TariffView.vue?vue&type=style&index=0&id=359db9ab&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-359db9ab"]])

export default __exports__